module.exports = __webpack_public_path__ + "img/slider-people-5.4879873b.png";